import * as React from 'react';
import { cn } from '@/lib/utils';

export interface AvatarProps {
  src?: string;
  alt?: string;
  initials?: string;
  size?: 'sm' | 'md' | 'lg';
  backgroundColor?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'size-6 text-xs',
  md: 'size-7 text-sm',
  lg: 'size-10 text-base',
};

function Avatar({ src, alt, initials, size = 'md', backgroundColor = 'bg-surface-100 hover:bg-surface-200 transition-colors duration-200', className }: AvatarProps) {
  const [imageError, setImageError] = React.useState(false);
  const sizeClass = sizeClasses[size];

  // Reset error state when src changes
  React.useEffect(() => {
    setImageError(false);
  }, [src]);

  // Show image if src is provided and hasn't errored
  if (src && !imageError) {
    return (
      <div
        className={cn(
          'relative rounded-full overflow-hidden border border-border-primary',
          sizeClass,
          className
        )}
      >
        <img
          src={src}
          alt={alt || 'Avatar'}
          className="absolute inset-0 w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
      </div>
    );
  }

  // Fallback: show initials or user icon
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full text-text-secondary font-medium border border-border-primary',
        backgroundColor,
        sizeClass,
        className
      )}
    >
      {initials ? (
        initials
      ) : (
        <i className="pi pi-user" />
      )}
    </div>
  );
}

export { Avatar };
